import { Component, OnInit } from '@angular/core';
import { PermissionDeniedService } from 'src/app/core/services/permission-denied.service';

@Component({
  selector: 'app-permission-denied-popup',
  templateUrl: './permission-denied-popup.component.html',
  styleUrls: ['./permission-denied-popup.component.scss']
})
export class PermissionDeniedPopupComponent implements OnInit {
  show = false;
  permission = '';

  constructor(private permissionDeniedService: PermissionDeniedService) { }

  ngOnInit(): void {
    this.permissionDeniedService.show$.subscribe(show => {
      this.show = show;
    });

    this.permissionDeniedService.permission$.subscribe(perm => {
      this.permission = perm;
    });
  }

  close() {
    this.permissionDeniedService.hide();
  }

  contactAdmin() {
    // Implement contact logic or just close for now
    // The requirement didn't specify what this button does besides existing
    this.close();
  }
}
